export type PolyFeePreviewStatus = 'ready' | 'loading' | 'unavailable';

/**
 * Resolve the presentation state for a Polymarket fee preview without ever
 * turning missing venue evidence into a fee-free estimate.
 */
export function polyFeePreviewStatus(args: {
  conditionId: string | null;
  scheduleKnown: boolean;
  scheduleUnavailable: boolean;
  scheduleLoading: boolean;
  scheduleError: string | null;
  roleKnown: boolean;
  feeKnown: boolean;
}): PolyFeePreviewStatus {
  if (args.feeKnown) return 'ready';
  if (!args.conditionId || args.scheduleError || args.scheduleUnavailable) {
    return 'unavailable';
  }
  if (args.scheduleLoading || !args.scheduleKnown) return 'loading';
  if (!args.roleKnown) return 'unavailable';
  return 'unavailable';
}

export function polyFeePreviewLabel(status: PolyFeePreviewStatus): string {
  if (status === 'loading') return 'fee loading…';
  if (status === 'unavailable') return 'fee unavailable';
  return '';
}
